import { usePage } from "@inertiajs/vue3";
import { watch } from "vue";

export function useEventEmitter() {
  const page = usePage();

  watch(
    () => page.props.events as any[],
    (events) => {
      for (const event of events) {
        window.dispatchEvent(
          new CustomEvent(event.name, {
            detail: event.data,
          })
        );
      }
    },
    { immediate: true }
  );
}
